// Copied from mdn's Object.assign
function assign(target: any, ...sources: any[] /*, one or more source objects */) {
  // TypeError if undefined or null
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  const to = Object(target);
  for (let index = 0; index < sources.length; index++) {
    const nextSource = sources[index];

    if (nextSource != null) {
      // Skip over if undefined or null
      for (const nextKey in nextSource) {
        // Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey];
        }
      }
    }
  }

  return to;
}

function isEqual(value1: unknown, value2: unknown): boolean {
  // Handle null or undefined
  if (value1 === null || value2 === null) {
    return value1 === value2;
  }

  // Check if both values are of the same type
  if (typeof value1 !== typeof value2) {
    return false;
  }

  // Handle primitive types
  if (typeof value1 !== 'object') {
    return value1 === value2;
  }

  // Handle arrays
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return isEqualArray(value1, value2);
  }

  // Handle objects
  if (!Array.isArray(value1) && !Array.isArray(value2)) {
    return isEqualObject(value1 as Record<string, unknown>, value2 as Record<string, unknown>);
  }

  // If one is an array and the other is not
  return false;
}

function isEqualArray(arr1: unknown[], arr2: unknown[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  // Recursively compare each element
  for (let i = 0; i < arr1.length; i++) {
    if (!isEqual(arr1[i], arr2[i])) {
      return false;
    }
  }

  return true;
}

function isEqualObject(obj1: Record<string, unknown>, obj2: Record<string, unknown>): boolean {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  // Recursively compare each key-value pair
  for (const key of keys1) {
    if (!keys2.includes(key)) {
      return false;
    }
    if (!isEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export { assign, isEqual };
